import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer } from 'shared/components/Drawer/Drawer'
import { Pill } from 'shared/components/Pill/Pill'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { usePermission } from '../../hooks/usePermission'
import { PermissionType } from '../../models/permission'
import { closeConsultant, openConsultant } from '../../redux/actions/consultant/consultant'
import { isConsultantOpenSelector } from '../../redux/selectors/consultant'
import { ConsultantConversation } from './ConsulantConversation'
import { ConsultantTerms } from './ConsultantTerms'

const CONSULTANT_TERMS_KEY = 'CONSULTANT_TERMS_KEY'
const CONSULTANT_TERMS_VALUE = '1'

export function Consultant() {
  const dispatch = useDispatch()
  const isConsultantOpen = useSelector(isConsultantOpenSelector)
  const [areTermsAccepted, setAreTermsAccepted] = useState(
    localStorage?.getItem?.(CONSULTANT_TERMS_KEY) === CONSULTANT_TERMS_VALUE
  )
  const hasAiConsultantPermission = usePermission(PermissionType.AI_CONSULTANT)

  function handleClose() {
    dispatch(closeConsultant())
  }

  useEffect(() => {
    if (window.location.search.includes('open-consultant')) {
      dispatch(openConsultant())
    }
  }, [dispatch])

  if (!isConsultantOpen || !hasAiConsultantPermission.enabled) return null

  function onTermsSuccess() {
    setAreTermsAccepted(true)
    localStorage?.setItem?.(CONSULTANT_TERMS_KEY, CONSULTANT_TERMS_VALUE)
  }

  if (!areTermsAccepted) {
    return <ConsultantTerms onSuccess={onTermsSuccess} />
  }

  return (
    <Drawer
      isOpen={isConsultantOpen}
      onClose={handleClose}
      header={
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1">
            <TextV2 type={TYPOGRAPHY.header2} className="min-w-22">
              Ask Cai
            </TextV2>
            <Pill mb={0.7}>Beta</Pill>
          </div>
          <TextV2 type={TYPOGRAPHY.label3} className="text-light-gray1">
            This AI may occasionally make errors or inaccurate statements.
          </TextV2>
        </div>
      }
    >
      {(wrapRef) => <ConsultantConversation container={wrapRef} />}
    </Drawer>
  )
}
